<template>
  <div class="container">
    <Container :active_path="'/reallyWillBuy/shangban'" :plate="'项目巡览'">
      <div class="base-warp">
        <div>
            <el-row :gutter="15">
              <el-form ref="elForm" :model="formData"  size="small" label-width="100px"
                label-position="left">
                <el-col :span="24">
                    <el-form-item label="页面">
                      <tin-editor :value="formData.content" class="tin-editor" @input="getcontent"></tin-editor>
                    </el-form-item>
                  </el-col>
               
              </el-form>
            </el-row>
            <div slot="footer" style="text-align: center;">
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="handleConfirm">保存</el-button>
            </div>
      
        </div>

      
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"
import TinEditor from '../../../components/tin-editor.vue'  // 富文本

export default {
  components: {
    Container,TinEditor
  },
  data () {
    return {
      path: '/reallyWillBuy/shangban',
      plate: '商办资产',
      formData: {
        id: '',
        content:''
      },
    
    
    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    getcontent (content) {
      this.formData.content = content;
    },
    handleConfirm(){
      var params ={
        content : this.formData.content
      }
      this.$api.changecommercialAssets(params).then(res=>{
        this.$message(res)
        this.getTableData()
        // console.log(res);
      })
    },
    close(){
      this.formData.content = ''
      console.log('关闭');
    },
    getTableData(){
      console.log('huoqu');
      this.$api.getcommercialAssets().then(res=>{
        this.formData.content = res.content
        this.$forceUpdate()
        // console.log(res);
      })
    }
  
   
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.tin-editor {
  width: 100%;
}
</style>